import styled from '@app/styled';
import { color, spacing, typography } from '@app/theme';

export const Container = styled.div`
    min-height: calc(100vh - 270px);
    display: grid;
    justify-content: center;
    align-content: center;
    gap: ${spacing(4)};
`;

export const Heading = styled.h2`
    ${typography('custom.heading1')}
    text-align: center;
`;

export const Paragraph = styled.p`
    ${typography('custom.title2')}
    color: ${color('custom.content.secondary')};
    text-align: center;
`;
